import axios from "axios";

import { HaulerOption } from "../components/PickupRequestForm";

interface PickupRequestHaulerResponse {
  companyId: number;
  displayName: string;
  regNumber: number;
  divisionId: number;
}

export const getPickupRequestHaulers = (
  collectorId: number
): Promise<HaulerOption[]> =>
  axios
    .get<PickupRequestHaulerResponse[]>("/pickupRequests/haulers", {
      params: { collectorId },
    })
    .then(({ data }) =>
      data.map((hauler) => ({
        id: hauler.companyId,
        name: hauler.displayName,
        registrationNumber: String(hauler.regNumber),
        // eTracks regNumber, not RPRA - the haulers endpoint returns no RPRA number.
        divisionId: hauler.divisionId,
      }))
    );
